module.exports = __webpack_public_path__ + "img/cylinder-simple.372c102c.png";